import { PageAudienceFilter, usePageFilterContext } from '@/components/page';
import { PendoPlaceholder } from '@/components/PendoPlaceholder';
import ShareMenu from '@/features/ShareMenu';

type Props = {
  campaignIds: string[];
  isLoading: boolean;
};

const CampaignDetailActions = ({ campaignIds, isLoading }: Props) => {
  const {
    pageFilters: { audience },
  } = usePageFilterContext();

  return (
    <div className="flex items-center gap-2">
      <PendoPlaceholder />
      <PageAudienceFilter disabled={isLoading} />
      <ShareMenu
        notificationPageKey="campaign"
        notificationParams={{
          campaignIds: campaignIds!,
          audienceIds: audience?.id,
        }}
      />
    </div>
  );
};

export default CampaignDetailActions;
